import React, { useState } from 'react';
import { FormGroup, Label, Col, Row } from 'reactstrap';
import * as AsmTypes from '../../../../../models/CoreAsmModels';
import SelectInput from '../../../../misc/SelectInput';
import { useTranslation } from 'react-i18next';


interface NameObject {
    mappingType: string
    mappingValue: string
};

interface ValueObject {
    mappingType: number
    mappingValue: string | undefined
};

interface AsmMappingProps {
    title: string
    name: NameObject
    value: ValueObject
    defaultText: string
    disabled?: boolean
    invalid?: boolean
    invalidFeedback?: string
    onChange: (part: Partial<NameObject>) => void
};

const AsmMapping: React.FC<AsmMappingProps> = (props) => {
    const { t } = useTranslation(['configuration']);
    const [previous, setPrevious] = useState(props.value.mappingValue ?? undefined)

    const onChangeMappingTypes = (name: string, value: AsmTypes.AppleSchoolManagerUserMappingType | undefined) => {
        if (value !== AsmTypes.AppleSchoolManagerUserMappingType.ONPREMISESEXTENSIONATTRIBUTE) {
            props.onChange({ [name]: value, [props.name.mappingValue ]: undefined })
        } else if (value === AsmTypes.AppleSchoolManagerUserMappingType.ONPREMISESEXTENSIONATTRIBUTE && previous) {
            props.onChange({ [name]: value, [props.name.mappingValue]: previous })
        } else {
            props.onChange({ [name]: value });
        }
    }

    const onChangeMappingValue = (name: string, value: string | undefined) => {
        setPrevious(value);
        props.onChange({ [name]: value });
    }

    return (
        <FormGroup>
            <Label style={{ display: 'block' }}>{props.title}:</Label>
            <FormGroup>
                <Row>
                    <Col sm="3">
                        <SelectInput
                            items={AsmTypes.userMappingTypes.map(opt => ({ value: opt, text: t(`asm.userMappingTypes.${opt}`, { ns: 'configuration' }) }))}
                            onChange={(name, value) => onChangeMappingTypes(name, value)}
                            name={props.name.mappingType}
                            selected={props.value.mappingType}
                            defaultText={props.defaultText}
                            defaultValue={AsmTypes.userMappingTypes[0]}
                            disabled={props.disabled}
                        />
                    </Col>

                    <Col>
                        <SelectInput
                            items={AsmTypes.ExtensionAttributes.map(opt => ({ value: opt, text: opt }))}
                            onChange={(name, value) => onChangeMappingValue(name, value)}
                            name={props.name.mappingValue}
                            selected={props.value.mappingValue}
                            defaultText={`${t('asm.asmMapping.defaultText', { ns: 'configuration' })} ${props.title}`}
                            disableSort={true}
                            disabled={props.disabled || props.value.mappingType !== AsmTypes.AppleSchoolManagerUserMappingType.ONPREMISESEXTENSIONATTRIBUTE}
                            invalid={props.invalid}
                            invalidFeedback={props.invalidFeedback}
                        />

                    </Col>
                </Row>
            </FormGroup>
        </FormGroup>
    );
}

export default AsmMapping;
